/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable */
import dayjs from "dayjs"
import { SiteContext } from "libs/contexts"
import { dateFormat } from "libs/utils"
import { useContext, useEffect, useState } from "react"
import { Calendar } from "react-vant"
import { SearchProps } from "react-vant/es/search"
import { cls } from "reactutils"

const year = new Date().getFullYear()
const minDate = new Date(2018, 0, 1)
const maxDate = new Date(year, 11, 31)

export default function DateRange({
  placeholder = "请选择",
  value = {},
  title,
  name = "name",
  change,
  range,
}: SearchProps & {
  value?: any
  title?: string
  change: Function
  name?: string
  range: string[]
}) {
  const site = useContext(SiteContext)
  const [visible, setVisible] = useState(false)
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)

  const onConfirm = (e) => {
    setVisible(false)
    const newValue = {
      ...value,
      [range[0]]: dayjs(e[0]).startOf("d").toISOString(),
      [range[1]]: dayjs(e[1]).endOf("d").toISOString(),
    }
    change(newValue)
  }

  useEffect(() => {
    if (value) {
      setStartDate(value[range[0]])
      setEndDate(value[range[1]])
    }
  }, [value[range[0]], value[range[1]]])

  return (
    <>
      <div className="itemWrap">
        <div className="itemTitle">{title}</div>
        <div className={cls("text-panel")} onClick={() => setVisible(!visible)}>
          <div className={cls("current-box")}>
            {startDate ? (
              <div className="date">
                <span>{dateFormat(startDate)}</span>&emsp;至&emsp;
                <span>{dateFormat(endDate)}</span>
              </div>
            ) : (
              `${placeholder}${title}`
            )}
          </div>
        </div>
        <Calendar
          type="range"
          minDate={minDate}
          maxDate={maxDate}
          visible={visible}
          allowSameDay={true}
          onClose={() => setVisible(false)}
          onConfirm={onConfirm}
          color={site?.global?.platformMainColor}
        />
      </div>
      <style jsx>{`
        .custom-search {
          background-color: #fff;
          border: 1px solid #f1f1f1;
          border-radius: 0 0 3px 3px;
        }
        .text-panel {
          background: #f2f2f2;
          border-radius: 3px;
          display: flex;
          justify-content: space-between;
          padding: 13px 16px;
        }
        .itemWrap {
          padding: 10px 20px 17px 20px;
          border-bottom: 2px solid #f9f9f9;
        }
        .itemWrap:last-child {
          border-bottom: none;
        }

        .itemTitle {
          font-size: 15px;
          color: #262626;
          line-height: 13px;
          font-weight: bold;
          margin-bottom: 17px;
        }
        .back-box {
          display: flex;
          align-items: center;
          width: 20px;
          justify-content: flex-end;
        }
        .back-box :global(svg) {
          height: 14px;
        }
        .icon-box :global(svg) {
          transform: translateY(2px);
        }
        .custom-search :global(.rv-search__content) {
          align-items: center;
          height: 40px;
          background: #f2f2f2;
          border-radius: 3px;
        }
        .custom-search :global(.rv-search) {
          flex: 1;
        }
        .text-panel :global(svg) {
          transform: translate(2px, 4px) rotate(-90deg);
        }
        .open-pop :global(svg) {
          transform: translate(2px, 4px) rotate(90deg);
        }
        .search-list {
          max-height: 200px;
          overflow: hidden;
          overflow-y: auto;
        }
        .list-item {
          height: 40px;
          line-height: 40px;
          padding: 0 13px;
          font-size: 14px;
          color: #333333;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
        }
        .active {
          color: var(--primaryColor);
        }
        .nodata {
          font-size: 14px;
          color: #333333;
          text-align: center;
          padding-top: 10px;
          padding-bottom: 20px;
        }

        .close-box {
          display: flex;
          justify-content: flex-end;
          height: 40px;
          align-items: center;
          padding-right: 12px;
        }
        .date span {
          color: var(--primaryColor);
        }
      `}</style>
    </>
  )
}
